<script setup>
import { computed } from "vue";
import { Button, Icon } from "../../components";
import useChatWidget from "../stores/chatWidget";

const $chatWidget = useChatWidget();
const $globalSetting = computed(() => $chatWidget.getGlobalSettings());
const $config = $chatWidget.getConfig;
const $setting = $chatWidget.getSettings;
const $payload = computed(() => $chatWidget.getPayload());

const triggerChatWidget = () => {
  const tempConfig = $config;
  tempConfig.isActive = false;
  $chatWidget.updateConfig(tempConfig);

  const tempPayload = { step: 0 };
  $chatWidget.updatePayload(tempPayload);
};

const default_banner =
  prebook?.url?.assets + "images/chat-customizer-top-banner.jpeg";
</script>

<template>
  <div
    class="h-[200px] px-4 py-[15px] bg-cover bg-center"
    :style="{
      backgroundImage: `url(${
        $setting.banner.image ? $setting.banner.image : default_banner
      })`,
      backgroundColor: $globalSetting.customizer.design.brand_color,
    }"
  >
    <div class="flex justify-between">
      <button
        @click="triggerChatWidget"
        class="cursor-pointer border-none bg-gray-800/20 backdrop-blur-sm rounded-full flex items-center justify-center w-[40px] h-[40px]"
      >
        <Icon name="arrowLeft" class="text-[#fff] w-6 h-6" />
      </button>
      <!-- <button
        class="cursor-pointer border-none bg-gray-800/20 backdrop-blur-sm rounded-full flex items-center justify-center w-[40px] h-[40px]"
      >
        <Icon name="dotsVertical" class="text-[#fff] w-6 h-6" />
      </button> -->
    </div>
  </div>
</template>
